import React from 'react';
import {
  Button,
  Link,
  Typography,
  CancelIcon,
} from '@forgeglobal/design-framework';
import { useStyles } from './style';
import { FORGETRUST } from '@tcs/common/assets/constants';

interface SecurityQuestionIsEmptyFormProps {
  onCancel: () => void;
}

const SecurityQuestionIsEmptyForm = ({
  onCancel,
}: SecurityQuestionIsEmptyFormProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.cardErrorContainer}>
        <CancelIcon className={classes.errorIcon} />
        <Typography variant="body2" className={classes.cardErrorTypography}>
          We are unable to reset your password because you have not yet provided
          a security question.
        </Typography>
      </div>
      <Typography variant="body1">
        Please reach out to our call center for further assistance.
      </Typography>
      <ul className={classes.helpText}>
        <li>
          <Typography variant="body1">
            call:{' '}
            <Link href={`tel:${FORGETRUST.PHONE}`}>{FORGETRUST.PHONE}</Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            email:{' '}
            <Link href={`mailto:${FORGETRUST.EMAIL}`}>{FORGETRUST.EMAIL}</Link>
          </Typography>
        </li>
      </ul>
      <div className={classes.buttons}>
        <Button
          size="medium"
          color="secondary"
          onClick={onCancel}
          data-test-id="previous-button">
          Previous
        </Button>
        <Button
          size="medium"
          color="primary"
          type="submit"
          disabled={true}
          className={classes.primaryButton}
          data-test-id="submit-button">
          NEXT
        </Button>
      </div>
    </div>
  );
};

export default SecurityQuestionIsEmptyForm;
